export const environment = {
    production: false,
    superAdminApiEndpoint: "https://smm.saslabai.com/rest-api/public/api/admin/user/v1/",
    apiEndpoint: "https://smm.saslabai.com/rest-api/public/api/end/user/v1/",
    automationBaseUrl: 'http://localhost:8000/api/v1',
    apiKey: 'your-key',
    defaultHttpTimeout: 15000,
    longHttpTimeout: 30000,
    superLongHttpTimeout: 120000,
    source: "ADMIN",
    label: 'DEVELOPMENT',
    imageBaseUrl: ""
};